import { render, staticRenderFns } from "./DocumentTemplateEditModal.vue?vue&type=template&id=71f8dec8&"
import script from "./DocumentTemplateEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports